import type { RouteObject } from "react-router-dom";
import Layout from "@/components/layout/Layout";
import ScrollToTop from "@/components/feature/ScrollToTop";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import CategoryPage from "../pages/category/page";
import ArticlePage from "../pages/article/page";
import AboutPage from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: (
      <>
        <ScrollToTop />
        <Layout />
      </>
    ),
    children: [
      { index: true, element: <Home /> },
      { path: "category/:slug", element: <CategoryPage /> },
      { path: "article/:slug", element: <ArticlePage /> },
      { path: "about", element: <AboutPage /> },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;